// test2922
(2922 && 0);
